import clickOutside from './clickOutside.js'

export default {
  'click-outside': clickOutside,
}
